import React, { useState, useEffect } from 'react'
import './Vaccation.css';
import Axios from 'axios'
import { host, Host } from '../App';
import { FaPlus, FaEdit, FaSave, FaTrash, FaCheck, FaClock, FaCalendarAlt, FaUser, FaFileAlt } from 'react-icons/fa';

function Vaccation() {
  const [employees, setEmployees] = useState([]);
  const [editable, seteditable] = useState(false);
  const [employeeName, setEmployeeName] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [reason, setReason] = useState('');
  var [vaccation_data, setvaccation_data] = useState([]);
  var [vac, setVac] = useState(0);
  const [del, setdel] = useState(0);

  var user = (window.localStorage.getItem("Name").replace(/[{""}]/g, ""));
  var [Emp_id, setEmp_id] = useState('');
  var token = (window.localStorage.getItem("acessToken"));
  const [rank, setrank] = useState(false);
  var Ranked = (window.localStorage.getItem("Rank"));
  var Stage = (window.localStorage.getItem("Stage"));
  var Section = (window.localStorage.getItem("Section"));

  useEffect(() => {
    if (Ranked === '"Admin"' && Stage === '"2"') {
      setrank(true);
    }
  }, [Ranked]);

  useEffect(() => {
    Axios.get(`https://` + Host + `/api/vaccation_data/${token}`).then((data) => {
      setvaccation_data(data.data); console.log(data.data);
    });
  }, [vac]);

  const updated_vac_data = () => {
    Axios.get(`https://` + Host + `/api/vaccation_data/${token}`).then((data) => {

      setvaccation_data(data.data);
    });
  }

  useEffect(() => {
    Axios.get(`https://` + Host + `/api/employees_all/${token}`).then((data) => {
      setEmployees(data.data);
    });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (employeeName.length > 0 && startDate.length > 0 && endDate.length > 0) {
      Emp_id = employees.find((x) => x.Name === employeeName).Emp_ID;
      console.log('Form submitted:', { employeeName, Emp_id, startDate, endDate, reason });
      const vac_data = { Emp_id, employeeName, startDate, endDate, reason, user, token };
      Axios.post(`https://` + Host + `/api/add_vaccation`, vac_data)
        .then((response) => {
          window.alert('Vacation added successfully!');
        })
        .catch((error) => {
          console.error(error);
          window.alert('Error adding vacation');
        });
    } else {
      window.alert("Please Enter all values")
    }
    setEmployeeName('');
    setStartDate('');
    setEndDate('');
    setReason('');
    setTimeout(function () {
      updated_vac_data();
    }, 3000);
  };

  const [changedLine, setChangedLine] = useState(new Set());
  const handleInputChange = (e, index, key) => {
    const { value } = e.target;
    updateDatas(index, key, value);
  };

  const updateDatas = (index, key, value) => {
    setvaccation_data(prevData => {
      const newData = [...prevData];
      newData[index][key] = value;
      return newData;
    });
    setChangedLine(prevRows => new Set(prevRows).add(index));
  };

  const Update = () => {
    const changedData_ = [...changedLine].map(index => {
      return vaccation_data[index];
    });
    Axios.post(`https://` + Host + `/api/vacation/Update`, { changedData: JSON.stringify(changedData_), token: token }).then((response) => {
      if (response.status === 200) {
        window.alert(response.data.message);
      }
      seteditable(false);
      setdel(del + 1);
    })
      .catch(function (error) {
        console.log(error.response);
      });
  }

  const Manager_Approve = (Vaccation_ID) => {
    const Column = "Manager_Approval";
    Axios.post(`https://` + host + `/attendancedetails/approve/${Vaccation_ID},${Column},${user},${token}`).catch(function (error) {
      console.log(error.response);
    })
    setTimeout(function () {
      updated_vac_data();
    }, 2000);
  };

  const HR_Approve = (Vaccation_ID) => {
    const Column = "HR_Approval";
    Axios.post(`https://` + host + `/attendancedetails/approve/${Vaccation_ID},${Column},${user},${token}`).catch(function (error) {
      console.log(error.response);
    })
    setTimeout(function () {
      updated_vac_data();
    }, 2000);
  };

  const Delete = (Vaccation_ID) => {
    Axios.delete(`https://` + host + `/attendancedetails/delete/${Vaccation_ID},${token}`).catch(function (error) {
      console.log(error.response);
    })
    setTimeout(function () {
      updated_vac_data();
    }, 2000);
  }

  const getApprovalBadge = (status) => {
    switch (status) {
      case 'Approved': return <span className="badge approved"><FaCheck /> Approved</span>;
      case 'Pending': return <span className="badge pending"><FaClock /> Pending</span>;
      default: return <span className="badge">{status}</span>;
    }
  };

  return (
    <div className="vacation-container">
      <div className="vacation-header">
        <h1><FaCalendarAlt /> Vacation Management</h1>
        <p className="subtitle">Manage employee vacation requests and approvals</p>
      </div>

      <div className="vacation-grid">
        <div className="vacation-form-card">
          <div className="card-header">
            <h2><FaPlus /> New Vacation Request</h2>
          </div>
          <form onSubmit={handleSubmit} className="vacation-form">
            <div className="form-group">
              <label>
                <FaUser /> Employee Name
              </label>
              <div className="input-with-icon">
                <input
                  type='text'
                  className="form-control"
                  placeholder='Search employee...'
                  list='employee'
                  value={employeeName}
                  onChange={(e) => setEmployeeName(e.target.value)}
                  required
                />
                <datalist id="employee">
                  <option></option>
                  {employees.map(x => (
                    <option key={x.Emp_ID} value={x.Name}>{x.Name}</option>
                  ))}
                </datalist>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>
                  <FaCalendarAlt /> Start Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label>
                  <FaCalendarAlt /> End Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label>
                <FaFileAlt /> Reason
              </label>
              <textarea
                value={reason}
                className="form-control"
                placeholder="Enter vacation reason..."
                rows="3"
                onChange={(e) => setReason(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn-submit-vacation">
              <FaPlus /> Submit Vacation Request
            </button>
          </form>
        </div>

        <div className="vacation-list-card">
          <div className="card-header">
            <div className="header-content">
              <h2><FaCalendarAlt /> Active Vacations</h2>
              <div className="action-buttons">
                {editable ? (
                  <button className="btn-save" onClick={Update}>
                    <FaSave /> Save Changes
                  </button>
                ) : null}
                <button className="btn-edit" onClick={() => seteditable(!editable)}>
                  {editable ? <FaSave /> : <FaEdit />}
                  {editable ? 'Cancel Edit' : 'Edit'}
                </button>
              </div>
            </div>
          </div>

          <div className="table-container">
            <table className="vacation-table">
              <thead>
                <tr>
                  <th>Employee</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Reason</th>
                  <th>Registered By</th>
                  {rank && <th>Manager</th>}
                  {rank && <th>HR</th>}
                  {rank && <th>Actions</th>}
                </tr>
              </thead>
              <tbody>
                {vaccation_data.map((val, index) => (
                  <tr key={index} className={editable ? 'editable-row' : ''}>
                    <td className="employee-cell">
                      <div className="employee-avatar">
                        {val.Employee_Name.charAt(0)}
                      </div>
                      {val.Employee_Name}
                    </td>
                    <td>
                      {editable ? (
                        <input
                          type="date"
                          className="edit-input"
                          value={val.Start_Date.slice(0, 10)}
                          onChange={(e) => handleInputChange(e, index, 'Start_Date')}
                        />
                      ) : (
                        <span className="date-display">
                          {(val.Start_Date.slice(0, 10))}
                        </span>
                      )}
                    </td>
                    <td>
                      {editable ? (
                        <input
                          type="date"
                          className="edit-input"
                          value={val.End_Date.slice(0, 10)}
                          onChange={(e) => handleInputChange(e, index, 'End_Date')}
                        />
                      ) : (
                        <span className="date-display">
                          {(val.End_Date.slice(0, 10))}
                        </span>
                      )}
                    </td>
                    <td>
                      {editable ? (
                        <input
                          type="text"
                          className="edit-input"
                          value={val.Reason}
                          onChange={(e) => handleInputChange(e, index, 'Reason')}
                        />
                      ) : (
                        <span className="reason-text">{val.Reason}</span>
                      )}
                    </td>
                    <td>
                      <span className="registrar">{val.User}</span>
                    </td>
                    {rank && (
                      <td>
                        {Section === '"Manager"' ? (
                          val.Manager_Approval === "Pending" ? (
                            <button
                              className="btn-approve"
                              onClick={() => {
                                if (window.confirm("Approve this vacation?")) {
                                  Manager_Approve(val.Vaccation_ID);
                                }
                              }}
                            >
                              <FaCheck /> Approve
                            </button>
                          ) : (
                            getApprovalBadge(val.Manager_Approval)
                          )
                        ) : (
                          getApprovalBadge(val.Manager_Approval)
                        )}
                      </td>
                    )}
                    {rank && (
                      <td>
                        {Section === '"HR"' ? (
                          val.HR_Approval === "Pending" ? (
                            <button
                              className="btn-approve"
                              onClick={() => {
                                if (window.confirm("Approve this vacation?")) {
                                  HR_Approve(val.Vaccation_ID);
                                }
                              }}
                            >
                              <FaCheck /> Approve
                            </button>
                          ) : (
                            getApprovalBadge(val.HR_Approval)
                          )
                        ) : (
                          getApprovalBadge(val.HR_Approval)
                        )}
                      </td>
                    )}
                    {rank && (
                      <td>
                        <button
                          className="btn-delete"
                          onClick={() => {
                            window.confirm('Delete this entry?') && Delete(val.Vaccation_ID)
                          }}
                        >
                          <FaTrash />
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Vaccation